import Carousel from 'react-bootstrap/Carousel';
import Art1 from '../assets/images/image0.jpg';
import Art2 from '../assets/images/image1.jpg';
import Art3 from '../assets/images/image2.jpg';
import Art4 from '../assets/images/image3.jpg';
import Art5 from '../assets/images/image5.jpg';

function HomeCarousel() {
  return (
    <Carousel className='mb-4'>
      <Carousel.Item>
        <img className="radius-15 d-block w-100" src={Art2} alt="First slide" />
        <Carousel.Caption>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
        <img className="radius-15 d-block w-100" src={Art1} alt="Second slide" />
        <Carousel.Caption>
          {/* <h3>ಶ್ರೀ ಏಕನಾಥೇಶ್ವರಿ ದೇವಸ್ಥಾನ</h3>
          <p>Sri Ekanatheshwari Temple</p> */}
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
        <img className="radius-15 d-block w-100" src={Art3} alt="Third slide" />
        <Carousel.Caption>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
        <img className="radius-15 d-block w-100" src={Art4} alt="4 slide" />
        <Carousel.Caption>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
        <img className="radius-15 d-block w-100" src={Art5} alt="5 slide" />
        <Carousel.Caption>
          {/* <h3>ಉಡುಪಿ ಶ್ರೀ ಕೃಷ್ಣ ದೇವಸ್ಥಾನ</h3>
          <p>Udupi Shri Krishna Temple</p>*/}
        </Carousel.Caption>
      </Carousel.Item>
    </Carousel>
  );
}

export default HomeCarousel;